import { combineReducers } from 'redux';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import * as RequestStatus from 'automation-ui-canvas/constants/RequestStatus';
const groups = (state = {}, action) => {
  if (action.type === ActionTypes.RECEIVED_SUBSCRIPTION_GROUPS) {
    return action.payload;
  }
  return state;
};
const groupsRequestStatus = (state = RequestStatus.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.REQUESTED_SUBSCRIPTION_GROUPS:
      return RequestStatus.PENDING;
    case ActionTypes.RECEIVED_SUBSCRIPTION_GROUPS:
      return RequestStatus.SUCCEEDED;
    case ActionTypes.REQUESTED_SUBSCRIPTION_GROUPS_FAILED:
      return RequestStatus.FAILED;
    default:
      return state;
  }
};
const subscriptionsReducer = combineReducers({
  groups,
  groupsRequestStatus
});
export default subscriptionsReducer;